import React from 'react';
import { ThankYouPage } from './pages/ThankYouPage';
export function App() {
  return <ThankYouPage data-id="element-0" />;
}